






















































import { Prop, Vue } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules/decorators'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'

@Component
export default class AdminUserDropdown extends Vue {
  constructor(
    private readonly userBootUseCase: UserBootUseCase
  ) {
    super()
  }

  @Prop() showSwitch!: boolean

  @Prop() dark!: boolean

  get user() {
    return this.userBootUseCase.user
  }

  get loading() {
    return this.userBootUseCase.isLoading
  }

  logOut() {
    return this.userBootUseCase.logOut()
  }

}
